import { render, staticRenderFns } from "./AddEducation.vue?vue&type=template&id=5d385dd6&scoped=true&"
import script from "./AddEducation.vue?vue&type=script&lang=js&"
export * from "./AddEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d385dd6",
  null
  
)

export default component.exports